// 全体ステータス
export const OVERALL_STATUS = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
  REJECTED: 'rejected',
} as const;

export type OverallStatusType =
  (typeof OVERALL_STATUS)[keyof typeof OVERALL_STATUS];

export const OVERALL_STATUS_LABELS: Record<OverallStatusType, string> = {
  [OVERALL_STATUS.ACTIVE]: '進行中',
  [OVERALL_STATUS.COMPLETED]: '内定獲得',
  [OVERALL_STATUS.ARCHIVED]: '辞退',
  [OVERALL_STATUS.REJECTED]: '落選',
};

// エントリー完了状態
export const ENTRY_COMPLETION = {
  COMPLETED: true,
  NOT_COMPLETED: false,
} as const;

// 次の選考ステップ有無
export const HAS_LATEST_STEP = {
  WITH_LATEST_STEP: true,
  WITHOUT_LATEST_STEP: false,
} as const;

// フィルター項目の型
export type FilterValues = {
  overallStatus?: OverallStatusType[];
  hasCompletedEntry?: boolean;
  hasLatestStep?: boolean;
};
